import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const VideoStandardSettings = [
  LabelInput,
  {
    ...EntryTypeSelect,
    tooltip:
      "Videos can cause your submission files to be larger than normal. We recommend not adding more than 3 Video fields to ensure that your submissions and data upload successfully from your users' mobile devices.",
  },
  SettingsLabel('Config'),
  RequiredToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
